module.exports = __webpack_public_path__ + "static/media/IMG_2358.2c851d95.JPG";